import React, { CSSProperties } from 'react';
import './login.scss';

const AuthLayout = ({ children }: { children: React.ReactNode }) => {
  return (
    <div className="auth-container">
      {/* Lado izquierdo - Formulario */}
      <div className="auth-left-panel">
        {/* Mobile branded header */}
        <div className="auth-mobile-header">
          <img
            src="/rapi-fruti-logo.jpeg"
            alt="Rapi-Fruti Logo"
            className="auth-mobile-header__logo"
          />
          <span className="auth-mobile-header__name">Rapifruti</span>
          <span className="auth-mobile-header__tagline">
            Frutas y verduras a tu puerta
          </span>
        </div>

        {/* Form card */}
        <div className="auth-form-card">
          {/* Desktop-only logo */}
          <div className="auth-desktop-logo">
            <img src="/rapi-fruti-logo.jpeg" alt="Rapi-Fruti Logo" />
          </div>
          {children}
        </div>
      </div>

      {/* Lado derecho - Imagen */}
      <div className="auth-right-panel">
        <div style={styles.imageContainer}>
          <img
            src="/frutas-gpt.png"
            alt="Frutas frescas"
            style={styles.backgroundImage}
            loading="eager"
            decoding="sync"
          />
          <div className="auth-right-overlay">
            <span className="auth-right-overlay__title">Rapifruti</span>
            <span className="auth-right-overlay__sub">
              Frutas y verduras a tu puerta
            </span>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AuthLayout;

const styles: { [key: string]: CSSProperties } = {
  imageContainer: {
    position: 'absolute',
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    width: '100%',
    height: '100%',
    margin: 0,
    padding: 0,
  },
  backgroundImage: {
    position: 'absolute',
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    width: '100%',
    height: '100%',
    objectFit: 'cover',
    objectPosition: 'center',
    imageRendering: 'crisp-edges',
    filter: 'none',
    backfaceVisibility: 'hidden',
    transform: 'translateZ(0)',
    margin: 0,
    padding: 0,
    border: 'none',
    outline: 'none',
  },
};
